/*!
=========================================================
* Material Dashboard Angular - v2.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-angular2
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-angular2/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as moment from 'moment-timezone';
import 'moment/locale/es';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

moment.locale('es');
moment.tz.setDefault('Europe/Madrid');

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });

declare const gapi: any;

gapi.load('client', async () => {
  await gapi.client.init({
    apiKey: 'AIzaSyDcCHjSIeAUGs5Yt7B1SIcKyfi7KHr4MgI',
    discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
  });
});
